<template>
  <div style="height: 100" class="t-pa-md">
    <div style="height: 100%" class="wrapper">
      <div>
        <div v-for="(item, index) in templateItemsByLanguage" :key="index" class="text">
          <!--Preview SENDER -->
          <div v-if="item.item_type === TEMPLATE_ITEM_TYPE.SENDER">
            <div>
              <strong>{{ $t("distribution.new.message.from") }}</strong
              >: {{ item.email }}
            </div>
            <div class="q-mt-md">
              <strong>{{ $t("distribution.new.message.subject") }}</strong
              >: {{ item.subject }}
            </div>
          </div>
          <!-- Show Image -->
          <div v-if="item.item_type === TEMPLATE_ITEM_TYPE.IMAGE" :style="{ 'text-align': item.image_align }">
            <TPicture :image="item.image_src" :styles="{ 'max-height': '600px' }" />
          </div>
          <!-- Show Text -->
          <div v-if="item.text" v-html="item.text"></div>
          <!-- Show data booster -->
          <div v-if="item.item_type === TEMPLATE_ITEM_TYPE.DATA_BOOSTER && !successMessage">
            <Input v-model="name" class="t-mt-xl" leftIcon="Client" />
            <div class="flex-contents between t-mt-lg">
              <Input v-model="email" style="width: 46%" class="t-mt-md" leftIcon="Email" />
              <Input v-model="phone" style="width: 46%" placeholder="DDI + DDD + Number" class="t-mt-md" />
            </div>
            <center>
              <Button
                :handleClick="updateCustomer"
                :disabled="isLoading"
                :label="$t('survey.web.button_send')"
                class="mt-50"
              />
            </center>
          </div>
          <!-- Preview Start Survey -->
          <div v-if="item.item_type === TEMPLATE_ITEM_TYPE.START_SURVEY">
            <div v-if="item.text_button && item.start_button" class="start-container t-mt-lg">
              <Button :label="item.text_button" :customColor="item.button_color" />
            </div>
            <div v-else-if="scaleLayout" class="t-mt-lg">
              <div v-html="scaleLayout" class="flex-contents" style="width: 100%"></div>
              <div class="text-center t-mt-md">
                <div style="font-size: 14px; color: #828282">{{ item.scale_subtitle }}</div>
              </div>
            </div>
            <StartQuestionPlaceholder v-else :subtitle="item.scale_subtitle" />
          </div>
        </div>
        <div class="text">
          <center v-if="successMessage" style="margin-top: 100px">
            <i class="icon-check-circle" style="color: #54ca7e; font-size: 50px" />
            <div class="success-text q-mt-md">{{ $t("survey.web.customer_data_updated") }}</div>
          </center>
          <div class="push"></div>
        </div>
      </div>
    </div>
    <div class="footer text-center" v-if="showLogo">
      <img class="img" src="logo.png" style="" />
    </div>
  </div>
</template>
<script>
import { Button, Input } from "@tracksale/design-system";
import TPicture from "@/components/Picture";
import StartQuestionPlaceholder from "@/components/message/Components/StartQuestionPlaceholder";
import { mapActions, mapGetters } from "vuex";
import { TEMPLATE_ITEM_TYPE } from "@/consts/template";

export default {
  components: { Button, TPicture, StartQuestionPlaceholder, Input },
  props: {
    messageItems: Array,
    scaleLayout: String,
    customer: Object,
    lang: String,
    preview: Boolean,
    showLogo: Boolean
  },
  data() {
    return {
      successMessage: false,
      fontSize: "20px",
      name: this.preview ? "john doe" : this.customer?.name,
      phone: this.preview ? "" : this.customer?.phone,
      email: this.preview ? "mail@provider.com" : this.customer?.email
    };
  },
  computed: {
    ...mapGetters({
      isLoading: "ui/isLoading"
    }),
    templateItemsByLanguage() {
      if (!this.messageItems.length) {
        return [];
      }
      const templateItems = this.messageItems.filter((item) => item.language === this.lang);
      if (templateItems?.length) {
        return templateItems;
      }
      const secondLang = this.messageItems[0].language;
      return this.messageItems.filter((item) => item.language === secondLang);
    },
    TEMPLATE_ITEM_TYPE() {
      return TEMPLATE_ITEM_TYPE;
    }
  },
  methods: {
    ...mapActions({
      toggleLoading: "ui/toggleLoading",
      updateCustomerData: "survey/updateCustomerData"
    }),
    async updateCustomer() {
      if (this.preview) {
        this.successMessage = true;
        return;
      }
      this.toggleLoading(true);
      try {
        const data = {
          token: this.$route.params.token,
          data: {
            name: this.name,
            email: this.email,
            phone: this.phone
          }
        };
        await this.updateCustomerData(data);
        this.successMessage = true;
      } finally {
        this.toggleLoading(false);
      }
    }
  }
};
</script>
<style scoped lang="scss">
.text:not(:first-of-type) {
  padding-top: 50px;
}
.text {
  font-weight: normal;
  line-height: 1.5;
  color: #4e4e4e;
  max-width: 600px;
  margin: 0 auto;
  padding: 5px;
  ::v-deep img {
    max-width: 100%;
  }
}

.img {
  margin-top: 20px;
  width: 100px;
  height: auto;
}
.wrapper {
  min-height: 100%;
}
.footer,
.push {
  height: 50px;
  position: relative;
}
.success-text {
  font-weight: bold;
  font-size: 20px;
  line-height: 21px;
  color: #354052;
}
.start-container {
  display: flex;
  justify-content: center;
}
.flex-contents {
  display: flex;
}
.between {
  justify-content: space-between;
}
.text-center {
  text-align: center;
}
</style>
